import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reportActions } from '../../../store';
import { selectLanguage } from '../../../store/languageSlice';
import { selectReports } from '../../../store/reportsSlice';

const InPatientReportSwitch = (props) => {
    const dispatch = useDispatch();
    const { oldData, inPatient } = useSelector(selectReports);
    const { t } = useSelector(selectLanguage);
    const handleButtonClick = (old, inPat) => {
        console.log("handleButtonClick", old, inPat)
        // 0 for new
        // 1 for history
        //dispatch(reportActions.handleUpdateReportData(val));
        //dispatch(reportActions.handleUpdateReportData(oldData === 1 ? 0 : 1));
        dispatch(reportActions.handleUpdateReportData({old, inPat}));
    };


    
    return (
        <div className='in-ptnt-switch'>
            <button className={(oldData === 0 && inPatient === 0) ? 'active' : ''} type='button' title={t.OutPatient} onClick={()=>handleButtonClick(0, 0)}><img src={`${process.env.PUBLIC_URL}/images/icons/outpatient-rpt-icn.png`} alt="out patient" /></button>
            <button className={(oldData === 0 && inPatient === 1) ? 'active' : ''} type='button' title={t.InPatient} onClick={()=>handleButtonClick(0, 1)}><img src={`${process.env.PUBLIC_URL}/images/icons/inpatient-rpt-icn.png`} alt="in patient" /></button>
            <button className={(oldData === 1 && inPatient === 0) ? 'active' : ''} type='button' title={t.History} onClick={()=>handleButtonClick(1, 0)}><img src={`${process.env.PUBLIC_URL}/images/icons/history-rpt-icn.png`} alt="history" /></button>
        </div>
    )
};

export default InPatientReportSwitch;